import { trackingConstants } from '@frontend/sports/tracking/feature';

export const OVERASK_CATEGORIES = {
    overask: 'overask',
};

export const OVERASK_LABELS = {
    stakeLimitExceed: 'stake limit exceed',
    fullBetslip: 'full betslip',
};

export const OVERASK_ACTIONS = {
    load: 'load',
    exit: 'exit',
    click: 'click',
    betDenied: 'bet denied',
    tradersOffer: 'traders offer',
    tradersOfferExpired: 'traders offer expired',
    CTAclick: 'CTA-Click Betslip',
    betError: 'bet error',
};

export const OVERASK_EVENT_DETAILS = {
    stakeLimitExceededNotice: 'stake limit exceeded notice',
    pendingConfirmationPopup: 'cancel under review screen confirmation pop up',
    reviewConfirmationPopup: 'cancel offer confirmation',
    alternativeOfferForCustomer: 'alternative offer for customer',
    alternativeOfferForCustomerExpired: 'alternative offer for customer expired',
};

export type TrackingOfferType = 'new stake' | 'new odds' | 'new stake and new odds';
export type TrackingPendingActionType = 'get offer cta' | 'cancel offer cta';
export type TrackingReviewActionType = 'wait for offer cta' | 'cancel offer cta';

export const enum TrackingAcceptOfferLabelType {
    AcceptOfferAndPlaceBet = 'accept an offer & place bet cta',
    AcceptOfferChangesAndPlaceBet = 'accept changes and place a bet cta',
}

export const enum TrackingPendingRejectDialogActionType {
    GetOffer = 'get offer cta',
    CancelOffer = 'cancel offer cta',
}

export const enum TrackingReviewRejectDialogActionType {
    StayInOffer = 'wait for offer cta',
    CancelOffer = 'cancel offer cta',
}

export const Overask_Betypes = {
    sgp: 'sgp',
    sgpPlus: 'sgp+',
};

export interface TrackOveraskData {
    sku?: string[];
    [trackingConstants.COMPONENT_ACTION_EVENT]: string;
    [trackingConstants.COMPONENT_LABEL_EVENT]: string;
    [trackingConstants.COMPONENT_CATEGORY_EVENT]: string;
    [trackingConstants.COMPONENT_LOCATION_EVENT]: string;
    [trackingConstants.COMPONENT_POSITION_EVENT]: string;
    [trackingConstants.COMPONENT_EVENT_DETAILS]: string;
    [trackingConstants.COMPONENT_URL_CLICKED]: string;
}

export enum OverAskTrackingLocation {
    OverAskPending = 'bet under review screen',
    OverAskPendingRejectPopup = 'cancel under review screen confirmation pop up',
    OverAskReviewRejectPopup = 'cancel offer confirmation',
}
